import Cookies from 'js-cookie';

const links = document.querySelectorAll('a[href^="#"]');
links.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();

    const href = link.getAttribute('href');
    const targetSection = document.querySelector(href);
    const sectionTop = targetSection.getBoundingClientRect().top;
    const currentPos = window.scrollY;
    const gap = 84;
    const target = sectionTop + currentPos - gap;

    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.animate__up')
    .forEach(el => el.classList.add('add__transform__opacity'));

  const hiddenItems = document.querySelectorAll('.comiclist__item__hide');
  const button = document.querySelector('.comiclist__more');

  // If nothing is hidden, remove button
  if (!hiddenItems.length) {
    button?.remove();
    return;
  }

  if (!button) return;

  button.addEventListener('click', () => {
    hiddenItems.forEach(item => item.classList.remove('comiclist__item__hide'));

    button.remove();
  });
});
